import { waapi, animate, utils, createDraggable, spring, onScroll } from 'animejs';

const [ container ] = utils.$('html');

const $commonDuration = 450
const $commonDelay = 300
const $commonAnimSettings = 'bottom-=300 top'
const $commonAnimSettingsObject = {
    duration: $commonDuration,
    ease: 'outQuad',
    autoplay: onScroll({ 
      enter: 'bottom-=300 top'
    }) 
}

  export function animeLibrary(container, debug) {
    animate('.anime--fadein', {
      opacity: [0, 1],
      ...$commonAnimSettingsObject
  });
  
  document.querySelectorAll('.anime--slidefromleft').forEach(element => {
    // 1. Create a paused animation instance for this specific element
    const animationFromLeft = animate(element, {
      translateX: [-100, 0],
      opacity: [0, 1],
      duration: $commonDuration,
      ease: 'outQuad',
      autoplay: false // Keep it paused initially
    });

    // 2. Use onScroll to cleanly play() it exactly when it hits the viewport
    animate(element, {
      autoplay: onScroll({
        target: element,
        enter: $commonAnimSettings, // Triggers 50px before entering viewport
        onEnter: () => {
          animationFromLeft.play(); // Clean play execution
        }
      })
    });
  });


  document.querySelectorAll('.anime--slidefromright').forEach(element => {
    // 1. Create a paused animation instance for this specific element
    const animationFromRight = animate(element, {
      translateX: [100, 0],
      opacity: [0, 1],
      duration: $commonDuration,
      ease: 'outQuad',
      autoplay: false // Keep it paused initially
    });

    // 2. Use onScroll to cleanly play() it exactly when it hits the viewport
    animate(element, {
      autoplay: onScroll({
        target: element,
        enter: $commonAnimSettings, // Triggers 50px before entering viewport
        onEnter: () => {
          animationFromRight.play(); // Clean play execution
        }
      })
    });
  });

  animate('.anime--slidefromtop', {
    translateY: [-100, 0],
    duration: $commonDuration,
    ease: 'outQuad',
    autoplay: onScroll({ 
      enter: $commonAnimSettings
    })
  });

  document.querySelectorAll('.anime--slidefromtop-delay400').forEach(element => {
    // 1. Create a paused animation instance for this specific element
    const animationFromTop400 = animate(element, {
      translateY: [-100, 0],
      opacity: [0, 1],
      duration: $commonDuration,
      delay: 400,
      ease: 'outQuad',
      autoplay: false // Keep it paused initially
    });

    // 2. Use onScroll to cleanly play() it exactly when it hits the viewport
    animate(element, {
      autoplay: onScroll({
        target: element,
        enter: $commonAnimSettings, // Triggers 50px before entering viewport
        onEnter: () => {
          animationFromTop400.play(); // Clean play execution
        }
      })
    });
  });

  document.querySelectorAll('.anime--slidefromtop-delay500').forEach(element => {
    // 1. Create a paused animation instance for this specific element
    const animationFromTop500 = animate(element, {
      translateY: [-100, 0],
      opacity: [0, 1],
      duration: $commonDuration,
      delay: 500,
      ease: 'outQuad',
      autoplay: false // Keep it paused initially
    });

    // 2. Use onScroll to cleanly play() it exactly when it hits the viewport
    animate(element, {
      autoplay: onScroll({
        target: element,
        enter: $commonAnimSettings, // Triggers 50px before entering viewport
        onEnter: () => {
          animationFromTop500.play(); // Clean play execution
        }
      })
    });
  });

  animate('.anime--slidefromtop-delay600', {
    opacity: [0, 1],
    translateY: [-100, 0],
    duration: $commonDuration,
    delay: 600,
    ease: 'outQuad',
    autoplay: onScroll({ 
      enter: $commonAnimSettings
    })
  });

  animate('.anime--slidefrombottom', {
    translateY: [0, -100],
    duration: $commonDuration,
    ease: 'outQuad',
    autoplay: onScroll({ 
      enter: $commonAnimSettings,
      sync: true
    })
  });

  const targetPercentage = 70; // The target fill amount (75%)

  const circumference = 2 * Math.PI * 90; // 565.48
  const targetOffset = circumference - (circumference * (targetPercentage / 100));

  animate('.anime--bar', {
    strokeDashoffset: [circumference, targetOffset],
    duration: 2000,
    easing: 'easeInOutExpo',
    autoplay: onScroll()
  });



  // Animate the text counter
  animate('.anime--percentage-number-one', {
    innerHTML: [0,1],
    duration: 2000,
    easing: 'linear',
    round: 1, // Round numbers to integers,
    modifier: utils.round(0),
    autoplay: onScroll(),
    update: function(anim) {
      console.log(anim)
    }
  });

  animate('.anime--percentage-number-fourpointfive', {
    innerHTML: [0,4.5],
    duration: 2000,
    easing: 'linear',
    round: 1, // Round numbers to integers,
    modifier: utils.round(1),
    autoplay: onScroll(),
    update: function(anim) {
      console.log(anim)
    }
  });

  animate('.anime--percentage-number-three', {
    innerHTML: [0,3],
    duration: 2000,
    easing: 'linear',
    round: 1, // Round numbers to integers,
    modifier: utils.round(0),
    autoplay: onScroll(),
    update: function(anim) {
      console.log(anim)
    }
  });

  animate('.anime--bar-adjusted', {
    strokeDashoffset: [circumference, targetOffset+91],
    duration: 2000,
    easing: 'easeInOutExpo',
    autoplay: onScroll()
  });


  animate('.moveMask', {
    translateY: [400, 0],
    scaleY: [0.1, 1],
    duration: 2000,
    delay: $commonDelay, 
    ease: 'outExpo',
    autoplay: onScroll({ 
      debug 
    })
  })

  animate('.moveMask-dashes', {
    translateY: [400, 0],
    scaleY: [0.1, 1],
    duration: 2000,
    delay: $commonDelay, 
    ease: 'outExpo',
    autoplay: onScroll({ 
      debug 
    })
  })

  animate('.moveMask-words', {
    translateY: [400, 0],
    duration: 2000,
    delay: $commonDelay, 
    ease: 'outExpo',
    autoplay: onScroll({ 
      debug 
    })
  })
}